// import { createSelector } from 'reselect';

export const selectApplicationState = state => state.application.toJS();
export const selectAppReady = state => state.application.get("appReady");
export const selectDataReady = state => state.application.get("dataReady");
export const selectLanguage = state => state.application.get("language");
export const selectMenuState = state => state.isMenuOpen;
export const selectUserState = state => state?.user;
export const selectFaqState = state => state.faq;
export const selectSidebarHome = state => state.application.get("isSidebarHome");
export const selectTerritory = state => state.application.get("territory");
export const selectClientReady = state => state.application.get("clientReady");
export const selectUnderMaintenance = state => state.application.get("underMaintenance");
export const selectApiBaseUrl = state => state.application.get("apis").get("base");
export const selectFormBaseUrl = state => state.application.get("apis").get("form");
export const selectMediaBaseUrl = state => state.application.get("apis").get("media");
export const selectHost = state => state.application.get("host");
export const selectFacebookID = state => state.application.get("ids").get("facebook");
export const selectWeChatID = state => state.application.get("ids").get("weChat");
export const selectTwitterID = state => state.application.getIn(["ids", "twitter"]);
export const selectCookiePolicy = state => state.application.get("cookiePolicy");
export const selectApplicationIsProcessing = state => state.application.get("applicationProcessing");
export const selectUserFeedback = state => state.application.get("userFeedback");
export const selectApplicationDebugMode = state => state.application.get("debugMode");
export const selectHeaderHidden = state => state.application.get("headerHidden");
export const selectApplicationType = state => state.application.get("applicationType");
//mine
export const selectCookieBannerState = state => state?.showCookieBanner;
export const selectAnimationIsOverState = state => state?.animationIsOver;
export const selectMarketBannerState = state => state?.showMarketBanner;
export const selectHeaderHeight = state => state?.headerHeight;
export const selectShowCartAlert = state => state.isCartAlertVisible;
export const selectSessionId = state => state.sessionId;
export const selectCartAlertItems = state => state.alertItems;
export const selectCartItemsState = state => state.cartItems;
export const selectShowCartRefreshBanner = state => state.isCartRefreshBannerVisible;
export const clubSelector = state => state.club;
export const staffInfoSelector = state => state.staffInfo;
export const selectComparisonToolApiBody = state => state.comparisonToolApiBody;
export const selectBecomeAMemberSummary = state => state.becomeAMemberSummary;
export const selectShowCheckoutProgressBar = state => state.progressBarIndex;
export const selectProgressBarData = state => state.progressBarSteps;
export const selectHideTrigger = state => state.isTriggerHidden;
export const selectModelShow = state => state.showModel;
